import {useState} from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import EnergySlider from '../components/EnergySlider/EnergySlider';
import '../assets/css/styles.css';
import Parser from "html-react-parser";
import { changeDimLevel, revertDimLevel } from '../../../Helpers/fetchDevices';

const PillarModal = ({ marker, onClose}) => {
  const [energyValue, setEnergyValue] = useState(100);
  if (!marker) return null;

  const systemMetrics = Array.isArray(marker.metrics[1])
    ? marker.metrics[1]
    : marker.metrics[1]?.data || [];

  return (
    <Modal open={!!marker} onClose={onClose}>
      <Box className="modal-box">
        <Typography variant="h4" gutterBottom>Στοιχεία Θέσης</Typography>
        <Typography variant="h6">{marker.metrics[0][1]}</Typography>
        {marker.metrics && marker.metrics[0].slice(2).map((metric, idx) => (
          <Box key={idx} sx={{ my: 1 }}>{Parser(metric)}</Box>
        ))}

        <Card className="card-container">
          <Typography variant="subtitle1" gutterBottom>Επίπεδο Φωτισμού: {energyValue}</Typography>
          <EnergySlider value={energyValue} />
          <Box className="button-container">
            <Button variant="contained" fullWidth className="submit-btn" onClick={() => changeDimLevel(marker.deviceName, energyValue, "pillarControl")}>
              Αποστολή στη Συσκευή
            </Button>
            <Typography variant="body2" gutterBottom>
              Εάν αποστείλατε εντολή, επιλέξτε την επαναφορά στα προγράμματα σε περίπτωση που έχετε ενεργοποιήσει κάποιο πρόγραμμα για τη συσκευή αυτή.
            </Typography>
            <Button variant="contained" fullWidth onClick={() => revertDimLevel(marker.deviceName, "pillarControl")}>
              Επαναφορά στα Προγράμματα
            </Button>
          </Box>
        </Card>
          
        <Typography variant="subtitle1" gutterBottom>Μετρήσεις συστήματος:</Typography>
        
        {systemMetrics.map((metric, idx) => (
          <Box key={idx} sx={{ my: 1 }}>{Parser(metric)}</Box>
        ))}

      </Box>
    </Modal>
  );
};

export default PillarModal;
